import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Container, Typography, Button, Paper, Grid } from '@mui/material';

const Flowchart = ({ flowchartData, setView }) => {
  const [currentNode, setCurrentNode] = useState(flowchartData.startNode);

  const handleOptionClick = (nextNodeId) => {
    const nextNode = flowchartData.nodes.find((node) => node.id === nextNodeId);
    if (nextNode) {
      setCurrentNode(nextNode);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
    >
      <Container maxWidth="md">
        <Paper className="glass-card">
          <Typography variant="h4" component="h2" gutterBottom>
            {currentNode.text}
          </Typography>
          {currentNode.options && (
            <Grid container spacing={2} justifyContent="center">
              {currentNode.options.map((option, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Button
                      variant="contained"
                      fullWidth
                      onClick={() => handleOptionClick(option.nextNodeId)}
                    >
                      {option.text}
                    </Button>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          )}
          {currentNode.isEnd && (
            <div>
              <Typography variant="h6" component="p" gutterBottom>
                {flowchartData.endMessage}
              </Typography>
              <Button variant="contained" onClick={() => setView('home')}>
                Back to Home
              </Button>
            </div>
          )}
        </Paper>
      </Container>
    </motion.div>
  );
};

export default Flowchart;
